module.exports = __webpack_public_path__ + "img/amigos_mujer.580069b3.webp";